import { Image } from 'primereact/image';
import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import Layout from "../../../../components/common/nav/initiator/nav.component";
import { Button } from 'primereact/button';
import { MyAccountTable } from '../../../../components/service/myaccounttable';
import { DataTable } from 'primereact/datatable';
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import { ValidateInitiatorRole } from '../../../../helper/validateRole';
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import sideBarRight from "../../../../assets/images/sidebarright.svg"
import user1 from "../../../../assets/images/user1.svg"
import { Dialog } from "primereact/dialog";
import Login from '../../../../setup/auth/login.component';
import { Employee, Schools, ReportsLog, AbsentCode, CertificatedAdminWeeklyAbsenceReport, CertificatedAdminWeeklyAbsenceReportEmployee, CertificatedAdminWeeklyAbsenceReportEmployeeDetails, CertificatedAdminWeeklyAbsenceReportStatus } from "../../../../models";
import moment from "moment";
import { handleNotificationsOnStatusChangeforWeeklyAbsenceReportAdmin } from '../../../../components/actions/notficationActions';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { GetValueFromArray, graphQLGetAllData, graphQLFindRecordById } from "../../../../helper/commonfunctions";
import AWS from "aws-sdk";
import awsmobile from "../../../../aws-exports";
import ReactFullscreen from 'react-easyfullscreen';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FilterMatchMode, } from 'primereact/api';
import { Dropdown } from "primereact/dropdown";
import { useReactToPrint } from "react-to-print";
import '../../../../components/printwirformat/main.css'
import EditCertifiedAdminPopup from '../../../../components/certified_admin_popups/editpopup';
import { Timeline } from 'primereact/timeline';
import handleDateSelect from '../../../../helper/convertDateIntoPSTFormat';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TabPanel, TabView } from 'primereact/tabview';
import ReportDeleteDialog from '../../../../components/reportSoftDelete';
import * as queries from "../../../../graphql/queries";
import * as mutations from '../../../../graphql/mutations';

import RestoreDialog from '../../../../components/reportArchive/RestoreDialog';
export default function WARCertificatedArchiveReport() {

  //SET AWS Configuration
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region,
  });

  let [formHistory, setFormHistory] = useState([]);
  const approveStatusOptions = (product) => {

    switch (product.status) {
      case 'Rejected':
        return 'danger';

      case 'APPROVAL_REJECTED':
        return 'danger';

      case 'Completed':
        return 'success';

      case 'Pending':
        return 'warning';

      case 'Closed':
        return 'success';
      case 'Approved':
        return 'success';

      case 'APPROVAL_ACCEPTED':
        return 'success';
      case 'Acknowledged':
        return 'success';

      case 'RESUBMITTED':
        return 'info';

      case 'SUBMITTED':
        return 'info';

      case 'Submitted':
        return 'info';
      case 'OPEN':
        return 'info';
      case 'Reviewed & resubmitted':
        return 'info';

      default:
        return null;
    }
  };

  const [myaccountt, setProducts] = useState([]);
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState('center');
  const [visibleRight, setVisibleRight] = useState(false);
  const [weeklyAbsenceReports, setWeeklyAbsenceReports] = useState([]);
  const [weeklyAbsenceReportSubmitted, setWeeklyAbsenceReportSubmitted] = useState();
  const [weeklyAbsenceReportApproved, setWeeklyAbsenceReportApproved] = useState();
  const [weeklyAbsenceReportRejected, setWeeklyAbsenceReportRejected] = useState();
  const [weeklyAbsenceReportPending, setWeeklyAbsenceReportPending] = useState();
  const [activate, setActivate] = useState("");
  const loggedUserId = reactLocalStorage.get('loggedUserId');
  const [reportLoading, setReportLoading] = useState(true);
  const [adminReportLoading, setAdminReportLoading] = useState(true);
  const [absentCodeList, setAbsentCodeList] = useState([]);

  //*state
  const [reportId, setReportId] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [status, setStatus] = useState('');
  const [submittedBy, setSubmittedBy] = useState('');
  const [submittedByDate, setSubmittedByDate] = useState("");
  const [approvedBy, setApprovedBy] = useState('');
  const [payrollBy, setPayrollBy] = useState('');
  const [approverDate, setApproverDate] = useState('');
  const [payrollDate, setPayrollDate] = useState('');

  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [administratorDatas, setAdministratorData] = useState([]);
  const [certificatedDatas, setCertificatedDatas] = useState([]);
  const [isMasterDataLoaded, setIsMasterDataLoaded] = useState(false);
  const [schoolList, setSchoolList] = useState([]);
  const [warCerIsSuperAdmin, setWarCerIsSuperAdmin] = useState(0)
  const [activeIndex, setActiveIndex] = useState(0);
  const { cerApprovedReportId } = useParams();
  const [restoreData, setRestoreData] = useState(null);

  const [isVisibleDelete, setIsVisibleDelete] = useState(false);
  const [isVisibleDeleteID, setIsVisibleDeleteID] = useState(null);

  const fullDay = "Full Day";

  const TimeSubmitted = (rowdata) => {
    return (rowdata.submittedOn !== null ? <span> {moment(rowdata.status_date_time).format("MM/DD/YYYY")} </span> : "-");
  }


  const [users, SetUsersList] = useState([]);
  const [reportLogList, SetReportLogList] = useState([]);


  const [comment, setComment] = useState([]);

  const [ReminderDialog, setreminderDialog] = useState(false);
  const [ReminderData, setreminderData] = useState(null);


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    workDuration: { value: null, matchMode: FilterMatchMode.CONTAINS },
    schoolName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    assigneeName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const [statuses] = useState(['Approved', 'Pending', 'Rejected', 'Submitted', 'Reviewed And Resubmitted', 'Closed']);

  let navigateTo = useNavigate();

  const show = (position) => {
    setPosition(position);
    setVisible(true);
  };

  const TaskStatusSL = (product) => {
    switch (product.status) {
      case 'Rejected':
        return 'danger';

      case 'Pending':
        return 'warning';

      case 'Submitted':
        return 'info';

      case 'Approved':
        return 'success';

      case "Closed":
        return "success";

      case 'Reviewed And Resubmitted':
        return 'warning';

      default:
        return null;
    }
  };

  // table configs starts
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const TaskStatusSLA = (product) => {
    return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
  };

  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const RemainderFunction = async (rowData) => {
    let status = 'REMINDER_CREATED'
    let userid = rowData.l1_authority
    if (rowData.approver_by) {
      status = "REMINDER_APPROVED1"
      userid = rowData.l2_authority
    }
    handleNotificationsOnStatusChangeforWeeklyAbsenceReportAdmin(status, rowData?.id, "WEEKLY_ABSENCE_REPORT_ADMIN", userid, loggedUserId);
    setreminderDialog(false);

  }

  const footerContentForReminder = (
    <div className="text-center">
      <div className="d-flex">
        <button
          onClick={() => { RemainderFunction(ReminderData) }}
          type="button"
          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
        // id="add-family-cancel-btn"
        >
          Yes
        </button>
        <button
          onClick={() => { setreminderDialog(false) }}
          type="button"
          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
          id="add-family-cancel-btn"
        >
          No
        </button>
      </div>
    </div>
  );

const alljobactionContent = (row) => {
        return (
            <div className="flex w-full items-center" >
			<>
                <Link
              to="#"
              className="py-2 px-2.5"
              onClick={() => {
                show("right");
                onClickPopup(row);
              }}
            >
              <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
            </Link>
                    <Link to='#'  title="restore" className="py-2 px-2.5 cursor-pointer" onClick={() => {
						setRestoreData(row);
                            setIsVisibleDelete(true)
                        }}>
                           <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="18" viewBox="0 0 30 30">
              <path d="M 15 3 C 12.053086 3 9.3294211 4.0897803 7.2558594 5.8359375 A 1.0001 1.0001 0 1 0 8.5449219 7.3652344 C 10.27136 5.9113916 12.546914 5 15 5 C 20.226608 5 24.456683 8.9136179 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.441216 7.8348596 21.297943 3 15 3 z M 4.3007812 9 L 0.30078125 15 L 3 15 C 3 21.635519 8.3644809 27 15 27 C 17.946914 27 20.670579 25.91022 22.744141 24.164062 A 1.0001 1.0001 0 1 0 21.455078 22.634766 C 19.72864 24.088608 17.453086 25 15 25 C 9.4355191 25 5 20.564481 5 15 L 8.3007812 15 L 4.3007812 9 z" fill="#667085"></path>
            </svg>
							</Link>
			</>
            </div>
        );
    };
	
	
  const alljobactionContent_old = (row) => {
    return (
      <div className="flex justify-center w-full grid grid-cols-3  gap-2 items-center" >
      {row.status === "Submitted" ? (
          <>
            <Link
              to="#"
              className="py-2 px-2.5"
              onClick={() => { navigateTo('/initiator/weekly_absent_report_certificated_admin_initiatereport/' + row.id); navigateTo(0) }}
            >
              <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>
            </Link>
            <Link
              to="#"
              className="py-2 px-2.5"
              onClick={() => {
                setreminderDialog(true)
                setreminderData(row)
              }}
            >
              <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
            </Link>
            <Link
              to="#"
              // icon="pi pi-trash"
              className="pi pi-trash py-2 px-2.5 pt-3 text-[#667085]"
              onClick={() => {
                setIsVisibleDeleteID(row.id);
                setIsVisibleDelete(true)
              }}
            />
          </>
        ) : row.status === "Approved" ? (
          <>
            <Link
              to="#"
              className="pb-2 pt-1 px-2.5"
              onClick={() => {
                show("right");
                onClickPopup(row);
              }}
            >
              <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
            </Link>
            <Link
              to="#"
              className="py-2 px-2.5"
              onClick={() => {
                setreminderDialog(true)
                setreminderData(row)
              }}
            >
              <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
            </Link>
            <Link
              to="#"
              // icon="pi pi-trash"
              className="pi pi-trash py-2 px-2.5 pt-3 text-[#667085]"
              onClick={() => {
                setIsVisibleDeleteID(row.id);
                setIsVisibleDelete(true)
              }}
            />
          </>
        ) : row.status === "Reviewed And Resubmitted" ?
          (
            <>
              <Link
                to="#"
                className="py-2 px-2.5"
                onClick={() => { navigateTo('/initiator/weekly_absent_report_certificated_admin_initiatereport/' + row.id); navigateTo(0) }}
              >
                <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>
              </Link>
              <Link
                to="#"
                className="py-2 px-2.5"
                onClick={() => {
                  setreminderDialog(true)
                  setreminderData(row)
                }}
              >
                <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
              </Link>
              <Link
                to="#"
                // icon="pi pi-trash"
                className="pi pi-trash py-2 px-2.5 pt-3 text-[#667085]"
                onClick={() => {
                  setIsVisibleDeleteID(row.id);
                  setIsVisibleDelete(true)
                }}
              />
            </>

          )
          : row.status === "Closed" ? (
            <>
              <Link
                to="#"
                className="pb-2 pt-1 px-2.5"
                onClick={() => {
                  show("right");
                  onClickPopup(row);
                }}
              >
                <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
              </Link>
              <Link
                to="#"
                className="py-2 px-5"></Link>
              <Link
                to="#"
                // icon="pi pi-trash"
                className="pi pi-trash py-2 px-2.5 pt-3 text-[#667085]"
                onClick={() => {
                  setIsVisibleDeleteID(row.id);
                  setIsVisibleDelete(true)
                }}
              />
            </>
          ) : (
            <>
              <Link
                to="#"
                className="py-2 px-2.5"
                onClick={() => { navigateTo('/initiator/weekly_absent_report_certificated_admin_initiatereport/' + row.id); navigateTo(0) }}
              >
                <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>
              </Link>
              <Link
                to="#"
                className="py-2 px-5"></Link>
              <Link
                to="#"
                // icon="pi pi-trash"
                className="pi pi-trash py-2 px-2.5 pt-3 text-[#667085]"
                onClick={() => {
                  setIsVisibleDeleteID(row.id);
                  setIsVisibleDelete(true)
                }}
              />
            </>
          )}

      </div>
    );
  };


  const getFormHistoryData = async (reportId) => {
    let particulerReportAllTransactionCycleRecord = await graphQLGetAllData("listWARCertificatedTransactionCycles", [{ reportId: { eq: reportId } }]);
    let particulerReportMetaRecord = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReports"
      , [{ id: { eq: reportId } }]
    );

    let formHistory = [];
    if (particulerReportAllTransactionCycleRecord.length > 0 && particulerReportMetaRecord) {
      particulerReportAllTransactionCycleRecord = particulerReportAllTransactionCycleRecord.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

      for (let i = 0; i < particulerReportAllTransactionCycleRecord.length; i++) {
        const employee = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: particulerReportAllTransactionCycleRecord[i].toEmployeeId } }])

        if (i == 0) {
          const employeeData = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: particulerReportMetaRecord[0].user_id } }])

          let obj = {
            status: 'Submitted',
            empTitle: 'Initiator',
            empName: employeeData[0]?.employee_name,
            date: handleDateSelect(particulerReportMetaRecord[0].createdAt)
          }
          formHistory.push(obj);
        }

        let empTitle = (particulerReportAllTransactionCycleRecord[i].toEmployeeId == particulerReportMetaRecord[0]?.l1_authority) ? "Approver" :
          (particulerReportAllTransactionCycleRecord[i].toEmployeeId == particulerReportMetaRecord[0]?.l2_authority) ? "Payroll" : "Initiator";
        let name = employee[0].employee_name;

        let obj = {
          status: (particulerReportAllTransactionCycleRecord[i].status == 'Open') ? 'Pending' :
            (particulerReportAllTransactionCycleRecord[i].status == 'Rejected') ? 'Rejected' :
              (particulerReportAllTransactionCycleRecord[i].status == 'Resubmit') ? 'Reviewed & resubmitted'
                : particulerReportAllTransactionCycleRecord[i].status,
          // status: particulerReportAllTransactionCycleRecord[i].status,
          empTitle: empTitle,
          empName: name,
          date: (particulerReportAllTransactionCycleRecord[i].status == 'Open') ? '-' : handleDateSelect(particulerReportAllTransactionCycleRecord[i]?.customUpdatedAt)
        }
        formHistory.push(obj);

        console.log("objobj:-", obj);

      }
    }
    setFormHistory(formHistory);
  }

  //* onclick popup
  const onClickPopup = async (requestData) => {
    setAdminReportLoading(false)
    setAdministratorData([])
    setCertificatedDatas([])
    setReportId(requestData.id);
    setComment(requestData.comment);
    loadReportLogs(requestData.id);
    let fromDate = moment(requestData.from_date, 'YYYY-MM-DD').format('MM/DD/YYYY'); setFromDate(fromDate);
    let toDate = moment(requestData.to_date, 'YYYY-MM-DD').format('MM/DD/YYYY'); setToDate(toDate);
    setSchoolName(requestData.schoolName); setStatus(requestData.status)
    const cognito = new AWS.CognitoIdentityServiceProvider();

    // var particularWeeklyAbsenceReport = await DataStore.query(CertificatedAdminWeeklyAbsenceReport, (c) =>
    //   c.id.eq(requestData.id));

    var particularWeeklyAbsenceReport = await graphQLFindRecordById("getCertificatedAdminWeeklyAbsenceReport", requestData.id)

    let firstApproval;
    let approveName;
    let payrollName;


    let fullName;
    let approveNameF;
    let payrollNameF;

    if (requestData.user_id) {
      try {
        firstApproval = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: requestData.user_id, }).promise();
        approveName = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: particularWeeklyAbsenceReport.l1_authority, }).promise();
        payrollName = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: particularWeeklyAbsenceReport.l2_authority, }).promise();

      } catch (e) {
      }
    }
    let firstName = firstApproval.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value;
    let lastName = firstApproval.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value;
    fullName = firstName + " " + lastName;
    approveNameF = approveName ? approveName.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value + " " + approveName.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value : ''
    payrollNameF = payrollName ? payrollName.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value + " " + payrollName.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value : ''

    setSubmittedBy(fullName);


    //------------------------------

    if (requestData.approver_by !== null) {
      let firstApproval2;
      if (requestData.approver_by) {
        try {
          firstApproval2 = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: requestData.approver_by, }).promise();
        } catch (e) {
        }
      }
      let firstName2 = firstApproval2.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value;
      let lastName2 = firstApproval2.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value;
      let fullName2 = firstName2 + " " + lastName2;
      setApprovedBy(fullName2);



    }

    if (requestData.payroll_by !== null) {
      let firstApproval2;
      if (requestData.payroll_by) {
        try {
          firstApproval2 = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: requestData.payroll_by, }).promise();
        } catch (e) {
        }
      }
      let firstName2 = firstApproval2.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value;
      let lastName2 = firstApproval2.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value;
      let fullName2 = firstName2 + " " + lastName2;
      setPayrollBy(fullName2);
    }


    let initiateDateTime;
    let approverDateTime;
    let payrollDateTime;
    let currentDateTime = moment();
    currentDateTime = moment(currentDateTime).format("YYYY-MM-DD HH:mm:ss");
    if (requestData.approver_date_time || requestData.payroll_date_time || requestData.createdAt
    ) {
      initiateDateTime = requestData.createdAt ? handleDateSelect(requestData.createdAt) : handleDateSelect(currentDateTime);

      setSubmittedByDate(initiateDateTime);
      approverDateTime = requestData.approver_date_time ? handleDateSelect(requestData.approver_date_time) : null
      setApproverDate(approverDateTime);
      payrollDateTime = requestData.payroll_date_time ? handleDateSelect(requestData.payroll_date_time) : null
      setPayrollDate(payrollDateTime);

      //   let initiateDateTime = requestData.createdAt ? moment(requestData.createdAt, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A") : null
      // setSubmittedByDate(initiateDateTime);
      //   let approverDateTime = requestData.approver_date_time ? moment(requestData.approver_date_time, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A") : null
      //   setApproverDate(approverDateTime);
      //   let payrollDateTime = requestData.payroll_date_time ? moment(requestData.payroll_date_time, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A") : null
      //   setPayrollDate(payrollDateTime);
    }

    //get particular report ids data

    // let array = [
    //   { status: 'Submitted', empTitle: 'Initiator', empName: fullName, date: initiateDateTime, icon: 'pi pi-shopping-cart', color: '#9C27B0', image: 'game-controller.jpg' },
    //   { status: (particularWeeklyAbsenceReport?.approver_status == 'APPROVAL_ACCEPTED') ? 'Approved' : 'Pending', date: approverDateTime, empTitle: `${'Approver ' + approveNameF}`, icon: 'pi pi-cog', color: '#673AB7' },
    //   // { status: 'Shipped', date: 'L2 Authority', icon: 'pi pi-shopping-cart', color: '#FF9800' },
    //   { status: (particularWeeklyAbsenceReport?.payroll_status == 'PAYROLL_ACCEPTED') ? 'Acknowledged' : "Pending", date: payrollDateTime, empTitle: `${'Payroll ' + payrollNameF}`, icon: 'pi pi-check', color: '#607D8B' }

    //   // { status: (particularWeeklyAbsenceReport?.payroll_status == 'PAYROLL_ACCEPTED') ? particularWeeklyAbsenceReport.payroll_status : "Pending", date: `${'Payroll ' + payrollNameF }`, icon: 'pi pi-check', color: '#607D8B' }
    // ];
    // setEvents(array);
    getFormHistoryData(requestData.id);

    if (requestData.id) {
      let newResponse = [];
      // var employeeResponses = await DataStore.query(CertificatedAdminWeeklyAbsenceReportEmployee, (c) => c.Certificated_Admin_Weekly_Absence_Report_id.eq(requestData.id));
      var employeeResponses = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployees", [{ Certificated_Admin_Weekly_Absence_Report_id: { eq: requestData.id } }])

      if (employeeResponses.length > 0) {
        for (let index = 0; index < employeeResponses.length; index++) {
          const item = employeeResponses[index];
          let employeeName;
          let employee_type = employeeResponses[index].employee_type;

          if (item.employee_id) {
            let employeeData = await getEmployeeResponse(item.employee_id);
            if (employeeData) {
              employeeName = employeeData.employee_name;
            } else {
              employeeName = "-";
            }
          } else {
            employeeName = "-";
          }

          // var employeeDetailsResponses = await DataStore.query(
          //   CertificatedAdminWeeklyAbsenceReportEmployeeDetails,
          //   (c) => c.Certificated_Admin_Weekly_Absence_Report_Employee_id.eq(item.id)
          // );

          var employeeDetailsResponses = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReportEmployeeDetails", [{ Certificated_Admin_Weekly_Absence_Report_Employee_id: { eq: item.id } }])

          for (let i = 0; i < employeeDetailsResponses.length; i++) {
            const detailItem = employeeDetailsResponses[i];

            let substitutedEmployeeName = "";
            if (detailItem.substitute_emp_id) {
              let substituteEmployeeData = await getEmployeeResponse(detailItem.substitute_emp_id);
              if (substituteEmployeeData) {
                substitutedEmployeeName = substituteEmployeeData.employee_name;
              } else {
                substitutedEmployeeName = "-";
              }
            } else {
              substitutedEmployeeName = "-";
            }

            let absentCodeName = "";
            // let absentCodeResponses = await DataStore.query(AbsentCode, detailItem.absent_code_id);
            let absentCodeResponses = await graphQLFindRecordById("getAbsentCode", detailItem.absent_code_id)

            if (absentCodeResponses) {
              absentCodeName = absentCodeResponses.code;
            } else {
              absentCodeName = "-";
            }

            let absent_date = moment(detailItem.absent_date).format("MM/DD/YYYY");


            newResponse.push({
              "employeeName": employeeName,
              "absent_date": absent_date,
              "absent_code_id": absentCodeName,
              "substitutedEmployeeName": substitutedEmployeeName,
              "partial_hour": detailItem.partial_hour,
              "employee_type": employee_type,
              "partial_min": detailItem.partial_min,
              "is_full_day": detailItem.is_full_day,
            });
          }
        }
        newResponse = newResponse.sort((a, b) => (a.absent_date).localeCompare(b.absent_date));
        newResponse = newResponse.sort((a, b) => (a.employeeName?.toLowerCase() ?? "").localeCompare(b.employeeName?.toLowerCase() ?? ""));

        const administratorData = newResponse.filter(item => item.employee_type === 'Administrator')
        const certificatedData = newResponse.filter(item => item.employee_type === 'Certificated')

        const sortedNamesAdmin = [...administratorData].sort((a, b) => {
          /* // Split names into first and last name
          const lastNameA = a.employeeName.split(' ')[1];
          const lastNameB = b.employeeName.split(' ')[1];

          // Compare last names
          if (lastNameA !== lastNameB) {
            return lastNameA.localeCompare(lastNameB);
          } else {
            // If last names are the same, compare first names
            const firstNameA = a.employeeName.split(' ')[0];
            const firstNameB = b.employeeName.split(' ')[0];

            if (firstNameA !== firstNameB) {
              return firstNameA.localeCompare(firstNameB);
            } else {
              // If first names are the same, compare dates (assuming dates are in YYYY-MM-DD format)
              const dateA = new Date(a.absent_date);
              const dateB = new Date(b.absent_date);

              return dateA - dateB;
            }
          } */
        });

        setAdministratorData(sortedNamesAdmin);
        const sortedNamesCerti = [...certificatedData].sort((a, b) => {
          // Split names into first and last name
          /*  const lastNameA = a.employeeName.split(' ')[1];
           const lastNameB = b.employeeName.split(' ')[1];
 
           // Compare last names
           if (lastNameA !== lastNameB) {
             return lastNameA.localeCompare(lastNameB);
           } else {
             // If last names are the same, compare first names
             const firstNameA = a.employeeName.split(' ')[0];
             const firstNameB = b.employeeName.split(' ')[0];
 
             if (firstNameA !== firstNameB) {
               return firstNameA.localeCompare(firstNameB);
             } else {
               // If first names are the same, compare dates (assuming dates are in YYYY-MM-DD format)
               const dateA = new Date(a.absent_date);
               const dateB = new Date(b.absent_date);
 
               return dateA - dateB;
             }
           } */
        });

        setCertificatedDatas(sortedNamesCerti);
        setReportEmployeeList(newResponse)
        setAdminReportLoading(true)
      } else {
        setReportEmployeeList([])
        setAdminReportLoading(true)
      }
    }
  }

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidateInitiatorRole()) { userHasAuthenticated(false); }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }

  //*get getEmployeeResponse
  const getEmployeeResponse = (id) => {
    console.log("calling here")
    let _employeeList = [...employeeList];
    var returnRecord = _employeeList.find(o => o.id === String(id));
    if (returnRecord !== null && returnRecord !== undefined) { return returnRecord; } else { return null; }
  }

  //*get getEmployeeResponse
  const getUserResponse = (id) => {
    let _userList = [...users];
    let getEmployeeResponse = _userList.filter((item) => item.Username === id)
    let firstName = GetValueFromArray(getEmployeeResponse[0].Attributes, "custom:firstName");
    let lastName = GetValueFromArray(getEmployeeResponse[0].Attributes, "custom:lastName");
    let fullName = firstName + " " + lastName;
    return fullName;
  }

  //Get Weekly Absent Report-Certificated-Admin List
  const BindList = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params =
    {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        // console.log(data)
        SetUsersList(data.Users);
      }
    });

    var AbsentCodeResponses = await graphQLGetAllData("listAbsentCodes")
    AbsentCodeResponses = AbsentCodeResponses.sort((a, b) => a.name.localeCompare(b.name));
    setAbsentCodeList(AbsentCodeResponses)
    loadAbsenceReport();
  }

  //*loadAbsenceReport
  const loadAbsenceReport = async () => {

    var weeklyAbsenceReport = await graphQLGetAllData("listCertificatedAdminWeeklyAbsenceReports");
    console.log("🚀 ~ file: SuperAdminDashboardWarCert.js:692 ~ loadAbsenceReport ~ weeklyAbsenceReport:", weeklyAbsenceReport)
    weeklyAbsenceReport =   weeklyAbsenceReport.filter(obj => obj.user_id === loggedUserId);
    weeklyAbsenceReport = weeklyAbsenceReport.sort((b, a) => a.status_date_time.localeCompare(b.status_date_time));
    //weeklyAbsenceReport = weeklyAbsenceReport.filter(report => report.isArchived === true);
    
   console.log(weeklyAbsenceReport,"weeklyAbsenceReport1")
			//Archive report
	weeklyAbsenceReport = weeklyAbsenceReport.filter((report) => {
		 //console.log(report.isArchivedUsers,"isArchivedUsers")
			  if (report.isArchivedUsers) {
				try {
				  //const jsonObject = JSON.parse(report.isArchivedUsers);
				  let jsonObject = JSON.parse(report.isArchivedUsers);
				  if(jsonObject.length){
				  jsonObject = jsonObject.find(item => item.userId === loggedUserId && item?.archiveDesignation === "Initiator" )
				  
				  console.log(jsonObject,"jsonObject")
				  if (jsonObject) {
					return report;
				  }
				  }
				} catch (error) {
				  console.error('Error parsing isArchivedUsers:', report);
				}
			  } else {
				//return report;
			  }
			});
			
console.log(weeklyAbsenceReport,"weeklyAbsenceReport2")

    let employeeListData1 = await graphQLGetAllData("listEmployees")
    let newResponse = [];
    if (weeklyAbsenceReport.length > 0) {
      for (let i = 0; i < weeklyAbsenceReport.length; i++) {
        let schoolName = "";
        let workDuration = "";
        let submittedOn = "";
        let status = "";
        let remark = "";

        //*Work Duration
        if (weeklyAbsenceReport[i].from_date && weeklyAbsenceReport[i].to_date) {
          let fromDate = moment(weeklyAbsenceReport[i].from_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
          let toDate = moment(weeklyAbsenceReport[i].to_date, 'YYYY-MM-DD').format("MM/DD/YYYY");
          workDuration = fromDate + " - " + toDate
        }
        else { workDuration = "-" }

        //*submitted On
        if (weeklyAbsenceReport[i].status_date_time !== null && weeklyAbsenceReport[i].status_date_time !== undefined) {

          // submittedOn = weeklyAbsenceReport[i].status_date_time !== null ? moment(weeklyAbsenceReport[i].status_date_time).format("MM/DD/YYYY") : "-";

          submittedOn = weeklyAbsenceReport[i].status_date_time;
        } else { submittedOn = "-" }


        // //*School Name
        if (weeklyAbsenceReport[i].school_id !== null && weeklyAbsenceReport[i].school_id !== undefined) {
          // var schoolResponses = await DataStore.query(Schools, (c) => c.id.eq(weeklyAbsenceReport[i].school_id));
          var schoolResponses = schoolList.find(o => o.id === weeklyAbsenceReport[i].school_id)
          if (schoolResponses) { schoolName = schoolResponses.name; } else { schoolName = ""; }

          // if (schoolResponses) { schoolName = schoolResponses.name; } else { schoolName = ""; }
        } else { schoolName = ""; }

        if (weeklyAbsenceReport[i].payroll_status !== null && weeklyAbsenceReport[i].payroll_status === CertificatedAdminWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED) {
          status = "Approved"; remark = "-";
        } else if (weeklyAbsenceReport[i].payroll_status !== null && weeklyAbsenceReport[i].payroll_status === CertificatedAdminWeeklyAbsenceReportStatus.PAYROLL_REJECTED) {
          status = "Rejected"; remark = weeklyAbsenceReport[i].payroll_remark;
        } else if (weeklyAbsenceReport[i].approver_status !== null && weeklyAbsenceReport[i].approver_status === CertificatedAdminWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED) {
          status = "Approved"; remark = "-";
        } else if (weeklyAbsenceReport[i].approver_status !== null && weeklyAbsenceReport[i].approver_status === CertificatedAdminWeeklyAbsenceReportStatus.APPROVAL_REJECTED) {
          status = "Rejected"; remark = weeklyAbsenceReport[i].approver_remark;
        } else if (weeklyAbsenceReport[i].payroll_status === null && weeklyAbsenceReport[i].approver_status === null && weeklyAbsenceReport[i].status === CertificatedAdminWeeklyAbsenceReportStatus.SUBMITTED) {
          status = "Submitted"; remark = "-";
        } else if (weeklyAbsenceReport[i].payroll_status === null && weeklyAbsenceReport[i].approver_status === null && weeklyAbsenceReport[i].status === CertificatedAdminWeeklyAbsenceReportStatus.OPEN) {
          status = "Pending"; remark = "-";
        } else if (weeklyAbsenceReport[i].payroll_status === null && weeklyAbsenceReport[i].approver_status === null && weeklyAbsenceReport[i].status === CertificatedAdminWeeklyAbsenceReportStatus.RESUBMITTED) {
          status = "Reviewed And Resubmitted"; remark = "-";
        }

        let assigneeName = "";
        let firstApproval = "";
        let x
        const cognito = new AWS.CognitoIdentityServiceProvider();
        try {
          if (weeklyAbsenceReport[i].approver_status == "APPROVAL_REJECTED") {
            firstApproval = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: weeklyAbsenceReport[i].user_id, }).promise();
            let firstName = firstApproval.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value;
            let lastName = firstApproval.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value;

            x = { firstName, lastName }
          } else {
            x = employeeListData1.find(u => {
              if (weeklyAbsenceReport[i].approver_status === null) {
                if (u.user_Id === weeklyAbsenceReport[i].l1_authority) {
                  return u
                }
              } else {
                if (weeklyAbsenceReport[i].approver_status && weeklyAbsenceReport[i].payroll_status) {
                } else {
                  if (u.user_Id === weeklyAbsenceReport[i].l2_authority) {
                    return u
                  }
                }
              }
            });
          }

          let fname = x?.firstName;
          let lname = x?.lastName;
          if (fname) {
            assigneeName = fname;
          }
          if (lname) {
            assigneeName += " " + lname;
          }
        } catch (e) {
          console.info(e)
        }

        console.log('assigneeName 🎈🎈🎈🎈', assigneeName)

        if (1) {
          newResponse.push({
            "id": weeklyAbsenceReport[i].id,
			"archiveDesignation":"Initiator",
            "user_id": weeklyAbsenceReport[i].user_id,
            "status": status,
            "school_id": weeklyAbsenceReport[i].school_id,
            "from_date": weeklyAbsenceReport[i].from_date,
            "to_date": weeklyAbsenceReport[i].to_date,
            "status_date_time": weeklyAbsenceReport[i].status_date_time,
            "approver_status": weeklyAbsenceReport[i].approver_status,
            "approver_by": weeklyAbsenceReport[i].approver_by,
            "approver_remark": weeklyAbsenceReport[i].approver_remark,
            "approver_date_time": weeklyAbsenceReport[i].approver_date_time,
            "payroll_status": weeklyAbsenceReport[i].payroll_status,
            "payroll_by": weeklyAbsenceReport[i].payroll_by,
            "payroll_date_time": weeklyAbsenceReport[i].payroll_date_time,
            "payroll_remark": weeklyAbsenceReport[i].payroll_remark !== null ? weeklyAbsenceReport[i].payroll_remark : "-",
            "schoolName": schoolName,
            "workDuration": workDuration,
            "submittedOn": submittedOn,
            "remark": remark && remark.length > 20 ? remark.substring(0, 20) + "..." : remark,
            "createdAt": weeklyAbsenceReport[i].createdAt,
            "updatedAt": weeklyAbsenceReport[i].updatedAt,
            "comment": weeklyAbsenceReport[i].comment,
            "l1_authority": weeklyAbsenceReport[i].l1_authority,
            "l2_authority": weeklyAbsenceReport[i].l2_authority,
            "customUpdatedAt": weeklyAbsenceReport[i].customUpdatedAt,
            assigneeName: status === "Pending" ? "-" : (assigneeName ? assigneeName : "-"),
          })
        }



        if (i === weeklyAbsenceReport.length - 1) {

          // let weeklyAbsenceReportForInitiator = newResponse.filter(obj => obj.user_id === loggedUserId);
          let weeklyAbsenceReportForInitiator = newResponse;
          console.log("🚀 ~ file: SuperAdminDashboardWarCert.js:802 ~ loadAbsenceReport ~ newResponse:", newResponse)
          setReportLoading(false)
          //weeklyAbsenceReportForInitiator = orderBy(weeklyAbsenceReportForInitiator,"createdAt","DESCENDING")
          const sortedData = [...weeklyAbsenceReportForInitiator].sort((a, b) => new Date(b.status_date_time) - new Date(a.status_date_time));

          setWeeklyAbsenceReports(sortedData)

          if (cerApprovedReportId) {
            // Check if editReportId matches any id in the array
            const isMatch = weeklyAbsenceReportForInitiator.filter((data) => data.id === cerApprovedReportId);
            console.log("isMatch", isMatch)

            if (isMatch && isMatch[0].status === "Rejected") {
              navigateTo("/initiator/reports/initiatereport/" + isMatch[0].id);
            }
            else {
              onClickPopup(isMatch[0])
              setVisible(true);
              show("right");

            }
          }

          //SubmittedCount
          const submittedCount = weeklyAbsenceReportForInitiator.filter(obj => obj.status === "Submitted")
          setWeeklyAbsenceReportSubmitted(submittedCount.length)

          //SubmittedCount
          const approvedCount = weeklyAbsenceReportForInitiator.filter((obj) => obj.status === "Approved");
          setWeeklyAbsenceReportApproved(approvedCount.length)

          //RejectedCount
          const rejectedCount = weeklyAbsenceReportForInitiator.filter((obj) => obj.status === "Rejected");
          setWeeklyAbsenceReportRejected(rejectedCount.length)

          //RejectedCount
          const pendingCount = weeklyAbsenceReportForInitiator.filter((obj) => obj.status === "Pending");
          setWeeklyAbsenceReportPending(pendingCount.length)
        }

      }

    } else {
      setReportLoading(false)
    }

  }

  const loadReportLogs = async (reportId) => {

    //*Report Logs Response
    // var loadReportLogsResponse = await DataStore.query(ReportsLog, (c) => c.report_id.eq(reportId));
    var loadReportLogsResponse = await graphQLGetAllData("listReportsLogs", [{ report_id: { eq: reportId } }])

    if (loadReportLogsResponse.length > 0) {
      let newResponse = [];
      for (let i = 0; i < loadReportLogsResponse.length > 0; i++) {

        let submittedUser;
        let name;
        let ProfilePic;
        let dateTime = moment(loadReportLogsResponse[i].date_and_time).format('HH:mm');
        //*Get user
        let userId = loadReportLogsResponse[i].user_id
        const cognito = await new AWS.CognitoIdentityServiceProvider();
        if (userId) {
          try {
            submittedUser = await cognito.adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: userId,
            }).promise();

            let exist = submittedUser ? submittedUser : '';
            let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
            let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
            name = firstName + " " + lastName
            let profilePath = GetValueFromArray(exist.UserAttributes, "picture");

            if (profilePath !== undefined) {
              await Storage.get(profilePath)
                .then(result => {
                  ProfilePic = result;
                });
            } else { ProfilePic = user1; }
          } catch (e) {
            //console.log(e)
          }
        } else {
        }
        newResponse.push({
          "id": loadReportLogsResponse[i].id, "report_id": loadReportLogsResponse[i].report_id, "comment": loadReportLogsResponse[i].comment, "date_and_time": loadReportLogsResponse[i].date_and_time,
          "user_id": loadReportLogsResponse[i].user_id, "createdAt": loadReportLogsResponse[i].createdAt, "dateTime": dateTime, "name": name, "ProfilePic": ProfilePic, "updatedAt": loadReportLogsResponse[i].updatedAt,
        })

        if (i === loadReportLogsResponse.length - 1) {
          SetReportLogList(newResponse);
        }
      }
    } else {
      SetReportLogList([]);
    }
  }

  const getMasterData = async () => {
    let schoolsArray = await graphQLGetAllData("listSchools")
    setSchoolList(schoolsArray)

    let employeeList = await graphQLGetAllData("listEmployees");
    // employeeList = employeeList.sort((a, b) => a.employee_name.localeCompare(b.employee_name));
    setEmployeeList(employeeList);

    setIsMasterDataLoaded(true)
  }

  useEffect(() => {
    // onLoad();
    // checkApplicationAccessibility()
    getMasterData();
    MyAccountTable.getProductsSmall().then((data) => setProducts(data.slice(0, 9)));
  }, []);

  useEffect(() => {
    if (isMasterDataLoaded === true) {
      BindList();
    }
  }, [isMasterDataLoaded]);

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
    );
  };


  const convertArrayOfObjectsToCSV = (data) => {
    const csvRows = [];
    const headers = Object.keys(data[0]);

    csvRows.push(headers.join(','));

    for (const row of data) {
      const values = headers.map((header) => row[header]);
      csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
  };

  const downloadCSV = (data, filename) => {
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };



  const exportFilteredDataToCSV = (fileName) => {
    const dataToExport = weeklyAbsenceReports.map(({ user_id, approver_by, approver_date_time, approver_remark, approver_status, comment, createdAt, from_date, to_date, payroll_by, payroll_date_time, payroll_remark, payroll_status, remark, schoolName, school_id, status_date_time, submittedOn, workDuration }) => ({
      "User ID": user_id, "Approver By": approver_by, "Approver Date Time": approver_date_time, "Approver Remark": approver_remark, "Submitted On": moment(submittedOn).format("MM/DD/YYYY"), "Approver Status": approver_status, "Comment": comment, "Remark": remark, "Created At": createdAt,
      "From Date": moment(from_date).format("MM/DD/YYYY"), "To Date": moment(to_date).format("MM/DD/YYYY"), "Payroll By": payroll_by, "Payroll Date Time": payroll_date_time, "Payroll Remark": payroll_remark, "Payroll Status": payroll_status, "School Name": schoolName, "School ID": school_id, "Status Date Time": status_date_time, "Work Duration": workDuration
    }));

    const csvData = convertArrayOfObjectsToCSV(dataToExport);
    downloadCSV(csvData, fileName);
  };



  return isAuthenticated ? (
    <>
      <ReactFullscreen>
        {({ onToggle }) => (

          <Layout pageTitle="All Forms" activeMenu="Archive"
            appId="WEEKLY_ABSENCE_REPORT_ADMIN"
            reDirectUrl={"/initiator/weekly_absent_report_certificated_admin"}
            reDirectUrlforSA={"/weekly_absent_report_certificated_admin/SuperAdminDashboard"}

            IsSuperadmin={warCerIsSuperAdmin}
            IsArchive={true} reDirectUrlforArchive={"/initiator/weekly_absent_report_certificated_admin/ArchiveReport"}
            >

            <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
              <div className="flex justify-end visible lg:hidden">
                <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

              </div>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                {/* <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-3">
                  <div>
                    <div id={activate} className="bg-[#FFFFFF] rounded-lg box-shadow-1 radius4 p-4 xl:p-[0.833vw] top-5 lg:sticky fixed -left-96 lg:left-0 lg:overflow-hidden lg:h-auto z-10" data-aos="fade-up" data-aos-duration="800">
                      <div className="flex justify-between text-[#101828] font-medium text-base tracking-[0.02em] xl:text-[0.932vw]">
                        <p>Forms</p>
                      
                      </div>

                      <div className="mt-4 h-[600px] xl:h-[38vw]  overflow-auto">

                        <div className="bg-[#0F1E4C]  radius4 p-[16px] xl:p-[0.833vw]">
                          <h6 className="font-medium text-[16px] text-[#fff] xl:text-[0.833vw] mb-2">Weekly Absent Report -Certificated-Admin</h6>
                          <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                            <div className="flex items-center gap-1">
                              <div className="bg-[#EAEFFF] text-[16px] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                {weeklyAbsenceReportSubmitted === 0 ? 0 : weeklyAbsenceReportSubmitted}
                              </div>
                              <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Submitted</div>
                            </div>
                            <div className="flex items-center gap-1">
                              <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                {weeklyAbsenceReportApproved === 0 ? 0 : weeklyAbsenceReportApproved}
                              </div>
                              <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Approved </div>
                            </div>
                            <div className="flex items-center gap-1">
                              <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                {weeklyAbsenceReportRejected === 0 ? 0 : weeklyAbsenceReportRejected}
                              </div>
                              <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Rejected</div>
                            </div>
                           
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
                  <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                    <div className="flex  md:flex-row  items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">

                      <div className='flex items-center gap-2 mb-[14px] md:mb-[0px]'>
                        <p className="text-[18px] md:text-[16px] xl:text-[0.938vw] text-[#101828] font-medium">Weekly Absent Report- Certificated Admin</p>
                        <Tag className='w-[50%] md:w-auto' severity="" value={`${weeklyAbsenceReports.length} Request`} style={{ background: '#EFF8FF', color: '#0487C8', marginTop: "-3px" }} rounded></Tag>
                      </div>

                      {/* <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                        <Link to='/initiator/weekly_absent_report_certificated_admin_initiatereport' className="w-full text-center tableBtn blue radius8">
                          <i className="gusd-pluse-circle mx-1.5 "></i>Initiate New Report</Link>
                        <div className="relative dropcheck">

                        </div>
                        <Link to="#" onClick={() => { exportFilteredDataToCSV("WeeklyAbsentReportCertifiedAdmin.csv") }} className=" " > <i className="pi pi-download "></i></Link>

                        <Link to="" onClick={() => {
                          onToggle();
                        }}> <i className="gusd-expand"></i></Link>
                      </div> */}
                    </div>


                    <TabView
                      activeIndex={activeIndex}
                      onTabChange={e => {
                        setActiveIndex(e.index);
                      }}
                    >
                      <TabPanel header="Archive Reports">

                        <div className={weeklyAbsenceReports.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                          <DataTable sortOrder="-1" sortField="submittedOn" className="custpaginator custIcons custmBtnTable custTable " filters={filters} filterDisplay="row" loading={reportLoading} scrollable value={weeklyAbsenceReports}
                            paginator={weeklyAbsenceReports.lenght > 0 ? false : true} responsiveLayout="scroll" rows={10} rowsPerPageOptions={[10, 20, 30]} >


                            <Column field="user_id" header="SL#" style={{ minWidth: '3rem' }} body={(data, options) => options.rowIndex + 1}></Column>
                            <Column field="workDuration" header="Week Duration" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }}></Column>
                            <Column field="schoolName" header="School / Department Name" filter filterPlaceholder="Search" sortable></Column>
                            <Column field="submittedOn" header="Submitted On" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }} body={TimeSubmitted}></Column>

                            <Column field="status" header="Status" body={TaskStatusSLA} filter filterElement={statusRowFilterTemplate} sortable style={{ minWidth: '8rem' }}></Column>

                            <Column
                              field="assigneeName"
                              header="Assignee"
                              filter
                              filterPlaceholder="Search"
                              sortable
                              style={{ minWidth: "5rem" }}
                            // body={TimeSubmitted}
                            ></Column>
                            <Column field="remark" header="Remarks" align='center' style={{ minWidth: '6rem' }}></Column>

                            <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={alljobactionContent} style={{ minWidth: '6rem' }}></Column>
                          </DataTable>
                        </div>
                      </TabPanel>
                    </TabView>



                    <Dialog className="relative reports-popup" visible={visible} position={position}
                      style={{ width: '60vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisible(false)} draggable={false} resizable={false}>
                      {adminReportLoading === true ?
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12">
                          <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                            <div className="p-5">
                              <Link onClick={() => {
                                setVisible(false)
                              }} className="py-3">
                                <Image src={sideBarRight} alt="user" width="24" height="24" /></Link>

                              <div className="text-[#113699] text-md lg:text-[0.833vw] font-bold">Glendale Unified School District</div>
                              <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Weekly Absent Report-Certificated Admin form</div>

                              <div className="pt-3">
                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                  <div className="font-medium">School or Department </div>
                                  <div className="font-semibold ">{schoolName}</div>
                                </div>
                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                  <div className="font-medium">From </div>
                                  <div className="font-semibold ">{fromDate}</div>
                                </div>
                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                  <div className="font-medium">To </div>
                                  <div className="font-semibold ">{toDate}</div>
                                </div>
                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                  <div className="font-medium">Status </div>
                                  <Tag severity="" value={status} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                </div>
                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                  <div className="font-medium">Approved By </div>
                                  <div className="font-semibold ">{approvedBy}</div>
                                </div>
                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw]">
                                  <div className="font-medium">Submitted By </div>
                                  <div className="font-semibold ">{submittedBy}</div>
                                </div>
                                <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw]">
                                  <div className="font-medium">Comment </div>
                                  <div className="font-semibold ">{comment}</div>
                                </div>

                              </div>



                              <>
                                <div className="text-[#344054] mt-2 text-md lg:text-[0.833vw] font-bold">Administrator</div>

                                <div className=" emp-simple-tbl">
                                  <DataTable value={administratorDatas} emptyMessage="No Absence" rowGroupMode="rowspan" groupRowsBy="employeeName">
                                    <Column field="employeeName" header="Name of Employee"></Column>
                                    <Column field="absent_date" header="Dates Absent"></Column>
                                    <Column field="absent_code_id" header="Absent Codes"></Column>
                                    <Column field="substitutedEmployeeName" header="Substitute"></Column>
                                    <Column field="partial_hour" body={(row) => {
                                      return (


                                        <h1>
                                          {row.is_full_day ? "Full Day"
                                            :
                                            (row.partial_hour === null ? "0" : row.partial_hour) + "." + (row.partial_min === null ? "0" : Number(row.partial_min / 60).toFixed(2).slice(-2).padStart(2, '0')) + "Hr"}

                                        </h1>



                                      )

                                    }}
                                      header="Total Hours"></Column>
                                  </DataTable>
                                </div>
                                <div className="text-[#344054] mt-2 text-md lg:text-[0.833vw] font-bold">Certificated</div>

                                <div className=" emp-simple-tbl">
                                  <DataTable value={certificatedDatas} emptyMessage="No Absence" rowGroupMode="rowspan" groupRowsBy="employeeName" >
                                    <Column field="employeeName" header="Name of Employee"></Column>
                                    <Column field="absent_date" header="Dates Absent"></Column>
                                    <Column field="absent_code_id" header="Absent Codes"></Column>
                                    <Column field="substitutedEmployeeName" header="Substitute"></Column>
                                    <Column field="partial_hour" body={(row) => {
                                      return (
                                        <h1>
                                          {row.is_full_day ? "Full Day"
                                            :
                                            (row.partial_hour === null ? "0" : row.partial_hour) + "." + (row.partial_min === null ? "0" : Number(row.partial_min / 60).toFixed(2).slice(-2).padStart(2, '0')) + "Hr"} </h1>
                                      )

                                    }}
                                      header="Total Hours"></Column>
                                  </DataTable>
                                </div>
                              </>

                              {adminReportLoading === true && administratorDatas.length === 0 && certificatedDatas === 0 ?
                                <div className='mt-8 font-bold' >No Absence
                                </div>
                                : null
                              }


                              <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                                <div className="text-[#344054] font-medium text-[14px] pb-3">Absence Codes - Legends</div>
                                <div className="grid grid-cols-1 md:grid-cols-2">
                                  <div className="text-[#344054] text-[12px]">

                                    {absentCodeList.length > 0 && absentCodeList.slice(0, 7).map((item, index) => {
                                      return (<>
                                        <div className="grid grid-cols-5 pb-0.5">
                                          <div className="col-span-1 font-semibold text-right"> {item.code}- </div>
                                          <div className="col-span-4 pl-1">{item.name}</div>
                                        </div>
                                      </>
                                      )
                                    })}
                                  </div>

                                  <div className="text-[#344054] text-[12px]">
                                    {absentCodeList.length > 0 && absentCodeList.slice(7, 14).map((item, index) => {
                                      return (<>
                                        <div className="grid grid-cols-5 pb-0.5">
                                          <div className="col-span-1 font-semibold text-right">{item.code}- </div>
                                          <div className="col-span-4 pl-1">{item.name}</div>
                                        </div>

                                      </>
                                      )
                                    })}

                                  </div>
                                </div>
                              </div>

                              <div onClick={handlePrint} className="printicon bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#FFF] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">

                                <i className="mr-3 gusd-print-outline"></i><span >Print</span>

                                {/* print layout start */}
                                <div style={{ display: "none" }} >


                                  <div ref={componentRef} className='printTable' id='divname'>
                                    <table className="print-component w-full">
                                      <thead className="table-header">
                                        <tr>
                                          <th>
                                            <div>
                                              {<>

                                                <div style={{ marginTop: "20px" }}>
                                                  <center className='font-bold text-[20px]' >GLENDALE UNIFIED SCHOOL DISTRICT
                                                  </center>
                                                  <center className='font-bold'>Weekly Absence Report - Certificated
                                                  </center>
                                                  <p className='float-right'><span className='font-bold'>School or Dept. :- </span>{schoolName} </p><br />

                                                  <p className='float-right'><span className='font-bold'>Period From :- </span>{fromDate}  </p><br />

                                                  <p className='float-right'><span className='font-bold'>Period To :- </span>{toDate} </p>
                                                  <br />
                                                  <p className='float-right'><span className='font-bold'>Submitted By :- </span>{submittedBy} </p>

                                                </div>
                                              </>}
                                            </div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            {<div>
                                              <p className='float-left' ><span className='font-bold'>Comment :- </span>{comment} </p>
                                              <br />

                                              <>
                                                <div className='mt-8 font-bold' >Administrator
                                                </div>
                                                {/*<table style={{ width: "100%", marginTop: "20px" }}>
                                                    <thead>
                                                    <tr>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }} >Name of Employee</th>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Dates Absent</th>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Absent Code</th>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Substitute</th>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Total Hours</th>
                                                    </tr>
                                                    </thead>
                                                    {
                                                      administratorDatas.map((item) => {
                                                        return (
                                                          <tr className='text-center'>
                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.employeeName}</td>
                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_date}</td>
                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_code_id}</td>
                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.substitutedEmployeeName}</td>
                                                            {item.is_full_day ?
                                                              <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{"Full Day"}</td>
                                                              :
                                                              <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.partial_hour}.{(item.partial_min === null ? "0" : Number(item.partial_min / 60 * 100).toFixed(0))} Hr </td>
                                                            }
                                                          </tr>
                                                        );
                                                      })
                                                    }

											</table>*/}


                                                <div className="my-custom-datatable">
                                                  <DataTable value={administratorDatas} emptyMessage="No Absence" rowGroupMode="rowspan" groupRowsBy="employeeName">
                                                    <Column field="employeeName" header="Name of Employee"></Column>
                                                    <Column field="absent_date" header="Dates Absent"></Column>
                                                    <Column field="absent_code_id" header="Absent Codes"></Column>
                                                    <Column field="substitutedEmployeeName" header="Substitute"></Column>
                                                    <Column field="partial_hour" body={(row) => {
                                                      return (
                                                        <h1>
                                                          {row.is_full_day ? "Full Day"
                                                            :
                                                            (row.partial_hour === null ? "0" : row.partial_hour) + "." + (row.partial_min === null ? "0" : Number(row.partial_min / 60).toFixed(2).slice(-2).padStart(2, '0')) + " Hr"} </h1>
                                                      )

                                                    }}
                                                      header="Total Hours"></Column>
                                                  </DataTable>
                                                </div>
                                              </>




                                              <>
                                                <div className='mt-8 font-bold' >Certificated
                                                </div>
                                                {/* <table style={{ width: "100%", marginTop: "20px" }}>
                                                  <thead>
                                                    <tr>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }} >Name of Employee</th>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Dates Absent</th>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Absent Code</th>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Substitute</th>
                                                      <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Total Hours</th>
                                                    </tr>
                                                    </thead>
                                                    {
                                                      certificatedDatas.map((item) => {
                                                        return (
                                                          <tr className='text-center'>
                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.employeeName}</td>
                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_date}</td>
                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_code_id}</td>
                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.substitutedEmployeeName}</td>
                                                            {item.is_full_day ?
                                                              <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{"Full Day"}</td>
                                                              :
                                                              <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.partial_hour}.{(item.partial_min === null ? "0" : Number(item.partial_min / 60 * 100).toFixed(0))} Hr </td>
                                                            }

                                                          </tr>
                                                        );
                                                      })
                                                    }

											</table>*/}

                                                <div className="my-custom-datatable">
                                                  <DataTable value={certificatedDatas} emptyMessage="No Absence" rowGroupMode="rowspan" groupRowsBy="employeeName" >
                                                    <Column field="employeeName" header="Name of Employee"></Column>
                                                    <Column field="absent_date" header="Dates Absent"></Column>
                                                    <Column field="absent_code_id" header="Absent Codes"></Column>
                                                    <Column field="substitutedEmployeeName" header="Substitute"></Column>
                                                    <Column field="partial_hour" body={(row) => {
                                                      return (
                                                        <h1>
                                                          {row.is_full_day ? "Full Day"
                                                            :
                                                            (row.partial_hour === null ? "0" : row.partial_hour) + "." + (row.partial_min === null ? "0" : Number(row.partial_min / 60).toFixed(2).slice(-2).padStart(2, '0')) + " Hr"} </h1>
                                                      )

                                                    }}
                                                      header="Total Hours"></Column>
                                                  </DataTable>
                                                </div>



                                              </>


                                              {adminReportLoading === true && administratorDatas.length === 0 && certificatedDatas.length === 0 ?
                                                <div className='mt-4 font-bold' >No Absence
                                                </div>
                                                : null
                                              }

                                              <div className='mt-4 font-bold' >ABSENCE CODES
                                              </div>

                                              <table style={{ width: "100%", marginTop: "7px" }}>
                                                <tr className='text-[12px]'>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>B - Bereavement</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>NA - Personal (Not Approved)</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>S - Suspension</td>
                                                </tr>
                                                <tr className='text-[12px]'>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>D - District Approved</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>OU - Other Unpaid</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>V - Vacation</td>
                                                </tr>
                                                <tr className='text-[12px]'>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>I - Illness</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>PA - Personal (Approved)</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>W - Witness (District)</td>
                                                </tr>
                                                <tr className='text-[12px]'>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>J - Jury Duty</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>WC - Worker's Compensation</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>DC - District Covid</td>
                                                </tr>
                                                <tr className='text-[12px]'>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>L - Last Day Worked</td>
                                                  <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>PN - Personal Necessity</td>
                                                </tr>

                                              </table>

                                              <p className='float-right font-bold'>
                                                <span>{'Submitted by:'}</span></p><br />
                                              <h2 className='float-right'>{submittedBy ? submittedBy : '-'} {submittedByDate ? submittedByDate : null} </h2><br />

                                              <p className='float-right font-bold'>
                                                <span>{'Approved by:'}</span>
                                              </p> <br />
                                              <h2 className='float-right'>{approvedBy ? approvedBy : null} {approverDate ? approverDate : null} </h2><br />
                                              <h2 className='float-right'>{payrollBy ? payrollBy : null} {payrollDate ? payrollDate : null}</h2>

                                            </div>}
                                          </td>
                                        </tr>
                                      </tbody>
                                      {/* <tfoot className="table-footer">
            <tr>
                <td>
                    {`Page Number ${1}`}
                </td>
            </tr>
        </tfoot> */}
                                    </table>
                                  </div>

                                </div>
                                {/* print layout end */}

                              </div>
                            </div>
                          </div>
                          <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">

                            <div className="p-5">
                              <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                              <div className="card custTable">

                                <Timeline value={formHistory}
                                  opposite={(item) => <Tag
                                    severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                    value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                      <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                      <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                      <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                      <div className="text-color-secondary text-[9px] ml-2">{item.date}</div>
                                    </div>} />

                              </div>
                            </div>
                          </div>

                          {/* <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                          <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>
                            <div> */}


                          {/* <div className='timeline_style flex flex-col justify-center'>
                              <div className='grid grid-cols-3 items-center'>
                                  <div className=''><Tag severity="nostatus" icon="gusd-dot" value="no status"></Tag></div>
                                  <div className='flex flex-col items-center'>
                                    <div className='h-[50px] bg-[#98A2B3] block w-[1px] -mb-2'></div>
                                    <div className='text-[#98A2B3] text-xs'><i className='gusd-dot'></i></div>
                                    <div className='h-[50px] bg-[#98A2B3] block w-[1px] -mt-2'></div>
                                  </div>
                                  <div className=''>
                                    <div className='text-xs font-normal -tracking-[0.24px] text-[#667085]'>Step 1</div>
                                    <div className='text-sm font-bold -tracking-[0.24px] text-[#113699]'>Initiator</div>
                                  </div>
                              </div>
                              <div className='grid grid-cols-3 items-center'>
                                  <div className=''><Tag severity="success" icon="gusd-dot" value="Approved"></Tag></div>
                                  <div className='flex flex-col items-center'>
                                    <div className='h-[50px] bg-[#98A2B3] block w-[1px] -mb-2'></div>
                                    <div className='text-[#98A2B3] text-xs'><i className='gusd-dot'></i></div>
                                    <div className='h-[50px] bg-[#98A2B3] block w-[1px] -mt-2'></div>
                                  </div>
                                  <div className=''>
                                    <div className='text-xs font-normal -tracking-[0.24px] text-[#667085]'>Step 2</div>
                                    <div className='text-sm font-bold -tracking-[0.24px] text-[#113699]'>Site Administrator / Dept Head</div>
                                  </div>
                              </div>
                              <div className='grid grid-cols-3 items-center'>
                                  <div className=''><Tag severity="rejected" icon="gusd-dot" value="Rejected"></Tag></div>
                                  <div className='flex flex-col items-center'>
                                    <div className='h-[50px] bg-[#98A2B3] block w-[1px] -mb-2'></div>
                                    <div className='text-[#98A2B3] text-xs'><i className='gusd-dot'></i></div>
                                    <div className='h-[50px] bg-[#98A2B3] block w-[1px] -mt-2'></div>
                                  </div>
                                  <div className=''>
                                    <div className='text-xs font-normal -tracking-[0.24px] text-[#667085]'>Step 3</div>
                                    <div className='text-sm font-bold -tracking-[0.24px] text-[#113699]'>Initiator</div>
                                  </div>
                              </div>
                              <div className='grid grid-cols-3 items-center'>
                                  <div className=''><Tag severity="submitted" icon="gusd-dot" value="Submitted"></Tag></div>
                                  <div className='flex flex-col items-center'>
                                    <div className='h-[50px] bg-[#98A2B3] block w-[1px] -mb-2'></div>
                                    <div className='text-[#98A2B3] text-xs'><i className='gusd-dot'></i></div>
                                    <div className='h-[50px] bg-[#98A2B3] block w-[1px] -mt-2'></div>
                                  </div>
                                  <div className=''>
                                    <div className='text-xs font-normal -tracking-[0.24px] text-[#667085]'>Step 4</div>
                                    <div className='text-sm font-bold -tracking-[0.24px] text-[#113699]'>Initiator</div>
                                  </div>
                              </div>
                              </div> */}

                          {/* <div className="card">
                                <Timeline value={events} opposite={(item) =><Tag 
                                severity={approveStatusOptions(item)}
                                 value={item.status}></Tag>} content={(item) => <small className="text-color-secondary">{item.date}</small>} />
                              </div> */}

                          {/* </div> */}


                          {/* </div> */}

                          {/* </div> */}

                        </div>
                        : <div className="card flex justify-content-center align-item-center position-absolute top-50 left-50">
                          <ProgressSpinner />
                        </div>
                      }
                    </Dialog>

                  </div>

                  {/* for reminder notification */}
                  <Dialog
                    header="Reminder"
                    visible={ReminderDialog}
                    style={{ width: "30vw" }}
                    onHide={() => {
                      setreminderDialog(false);
                    }}
                    closable={false}
                    footer={footerContentForReminder}
                  >
                    <p className="m-0 text-[#0487C8] text-center">
                      <i className="mr-2 pi pi-check-circle"></i>
                      <span className="font-medium text-[18px]">{`By clicking Yes, a reminder will be sent to ${ReminderData?.assigneeName} to approve the form. Click No to cancel.`}</span>
                    </p>
                  </Dialog>


                  <Sidebar visible={visibleRight} position="right" onHide={() =>
                    setVisibleRight(false)}
                    style={{ width: '60vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                    className="customesidebar1 responsivepoup responsivecustompopup">

                    {adminReportLoading === true ?
                      <EditCertifiedAdminPopup popupstate={() => setVisibleRight(false)}
                        fromDate={fromDate}
                        toDate={toDate}
                        schoolName={schoolName}
                        reportEmployeeList={reportEmployeeList}
                        status={status}
                        reportId={reportId}
                        bindList={() => loadAbsenceReport()}
                        type={"Initior"}
                      />

                      : <div className="card flex justify-content-center align-item-center position-absolute top-50 left-50">
                        <ProgressSpinner />
                      </div>
                    }
                  </Sidebar>
                </div>

                {
                  (isVisibleDelete) ?
                    <RestoreDialog
                      isVisibleDelete={isVisibleDelete}
                      setIsVisibleDelete={setIsVisibleDelete}
                      isVisibleDeleteID={isVisibleDeleteID}
                      getMasterData={() => loadAbsenceReport()}
					  restoreData={restoreData}
							loggedUserId={loggedUserId}
							
                      // setIsLoadData={() => setReportLoading(true)}
                      setIsLoadData={() => { }}
                      queries={queries.getCertificatedAdminWeeklyAbsenceReport}
                      tableName={"getCertificatedAdminWeeklyAbsenceReport"}
                      mutations={mutations.updateCertificatedAdminWeeklyAbsenceReport}
                    /> : null
                }
              </div>


            </div>
          </Layout>
        )
        }
      </ReactFullscreen>
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}